"use client"
import type { ReactNode } from "react"
import { Suspense } from "react"
import { LanguageProvider } from "../components/lang-context"

export const dynamicParams = false

type Props = {
    children: ReactNode
    params: Promise<{ lang: string }>
}

export default function MarketingLangLayout({ children, params }: Props) {
    return (
        <Suspense fallback={null}>
            <LanguageProvider langPromise={params}>
                {children}
            </LanguageProvider>
        </Suspense>
    )
}
